var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpBasic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 30,
    viewBox: "0 0 21 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9812 15C16.4279 17.5689 13.6106 19.2857 10.393 19.2857C7.17532 19.2857 4.35806 17.5689 2.80477 15C4.35806 12.4311 7.17532 10.7143 10.393 10.7143C13.6106 10.7143 16.4279 12.4311 17.9812 15ZM18.7435 13.3945C16.8497 10.8394 13.8144 9.18367 10.393 9.18367C6.97152 9.18367 3.93621 10.8394 2.04241 13.3945C1.70962 12.4612 1.52838 11.4559 1.52838 10.4082C1.52838 5.50523 5.49719 1.53061 10.393 1.53061C15.2888 1.53061 19.2576 5.50523 19.2576 10.4082C19.2576 11.4559 19.0763 12.4612 18.7435 13.3945ZM19.7224 15C20.4034 13.615 20.7859 12.0563 20.7859 10.4082C20.7859 4.65989 16.1329 0 10.393 0C4.65309 0 0 4.65989 0 10.4082C0 12.0563 0.382525 13.615 1.06351 15C0.382525 16.385 0 17.9437 0 19.5918C0 25.3401 4.65309 30 10.393 30C16.1329 30 20.7859 25.3401 20.7859 19.5918C20.7859 17.9437 20.4034 16.385 19.7224 15ZM18.7435 16.6055C16.8497 19.1606 13.8144 20.8163 10.393 20.8163C6.97152 20.8163 3.93621 19.1606 2.04241 16.6055C1.70962 17.5388 1.52838 18.5441 1.52838 19.5918C1.52838 24.4948 5.49719 28.4694 10.393 28.4694C15.2888 28.4694 19.2576 24.4948 19.2576 19.5918C19.2576 18.5441 19.0763 17.5388 18.7435 16.6055Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpBasic);
export default __webpack_public_path__ + "static/media/sp-basic.a03bba9c2f518d34642857115157a921.svg";
export { ForwardRef as ReactComponent };